var _path, _path2, _path3, _rect, _rect2, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFoundersPlatinum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 120 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16345 7.16344 0 16 0H104C112.837 0 120 7.16344 120 16V100C120 133.137 93.1371 160 60 160C26.8629 160 0 133.137 0 100V16Z",
    fill: "#B5B5C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 19C4 11.268 10.268 5 18 5H102C109.732 5 116 11.268 116 19V100C116 130.928 90.928 156 60 156C29.0721 156 4 130.928 4 100V19Z",
    fill: "url(#paint0_linear_12_2126)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 41C9 34.3726 14.3726 29 21 29H99C105.627 29 111 34.3726 111 41V100C111 128.167 88.1665 151 60 151C31.8335 151 9 128.167 9 100V41Z",
    fill: "url(#paint1_linear_12_2126)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 15,
    width: 40,
    height: 4,
    rx: 2,
    fill: "#9BAFC7"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12_2126)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12_2126",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 26,
    width: 159,
    height: 158
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 26,
    width: 70,
    height: 153,
    transform: "rotate(45 114 26)",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12_2126)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 41C9 34.3726 14.3726 29 21 29H99C105.627 29 111 34.3726 111 41V100C111 128.167 88.1665 151 60 151C31.8335 151 9 128.167 9 100V41Z",
    fill: "black",
    fillOpacity: 0.3
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0061 98.1117V80.3789L79.8251 107.5L60.0061 98.1117Z",
    fill: "#C0CBE0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8251 107.5L60.0061 80.3789L76.6958 85.5944L79.8251 107.5Z",
    fill: "#7289B6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6958 85.5948L60.0061 80.3793L92.3423 69.9482L76.6958 85.5948Z",
    fill: "#8EA3CB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4371 66.8193L60.0061 80.3797L92.3423 69.9486L70.4371 66.8193Z",
    fill: "#C0CBE0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0048 80.3793V47L70.4358 66.819L60.0048 80.3793Z",
    fill: "#8EA3CB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0061 98.1117V80.3789L40.1871 107.5L60.0061 98.1117Z",
    fill: "#8EA3CB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1871 107.5L60.0061 80.3789L43.3164 85.5944L40.1871 107.5Z",
    fill: "#E1F1FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3164 85.5948L60.0061 80.3793L27.6699 69.9482L43.3164 85.5948Z",
    fill: "#7289B6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5751 66.8193L60.0061 80.3797L27.6699 69.9486L49.5751 66.8193Z",
    fill: "#C0CBE0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0075 80.3793V47L49.5764 66.819L60.0075 80.3793Z",
    fill: "#E1F1FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5437 114.899C58.9191 113.378 61.0809 113.378 61.4563 114.899L62.2577 118.145C62.3912 118.686 62.8136 119.109 63.3545 119.242L66.6009 120.044C68.1216 120.419 68.1216 122.581 66.6009 122.956L63.3545 123.758C62.8136 123.891 62.3912 124.314 62.2577 124.854L61.4563 128.101C61.0809 129.622 58.9191 129.622 58.5437 128.101L57.7423 124.854C57.6087 124.314 57.1864 123.891 56.6455 123.758L53.399 122.956C51.8784 122.581 51.8784 120.419 53.399 120.044L56.6455 119.242C57.1864 119.109 57.6087 118.686 57.7423 118.145L58.5437 114.899Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12_2126",
    x1: 6.24,
    y1: 8.99815,
    x2: 35.479,
    y2: 114.606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463542,
    stopColor: "#A6A5B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898838,
    stopColor: "#D9D9DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12_2126",
    x1: 60,
    y1: 29,
    x2: 60,
    y2: 151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CA8C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#373F67"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12_2126"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 102,
    height: 122,
    fill: "white",
    transform: "translate(9 29)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoundersPlatinum);
export default __webpack_public_path__ + "static/media/foundersPlatinum.da25179b1215d0b581c40404c59c1798.svg";
export { ForwardRef as ReactComponent };